import { Space, Tag, Typography } from "antd";

// Frequent reasons for a rejection or for making a tutor passive (product decision 2026-10-13):
// one click writes it into the reason field, where it can still be edited.
export function ReasonPicker({
  reasons,
  onPick,
}: {
  reasons: readonly string[];
  onPick: (reason: string) => void;
}) {
  return (
    <Space direction="vertical" size={4} style={{ marginBottom: 12 }}>
      <Typography.Text type="secondary">Sık kullanılan gerekçeler:</Typography.Text>
      <Space wrap size={[4, 4]}>
        {reasons.map((reason) => (
          <Tag.CheckableTag key={reason} checked={false} onChange={() => onPick(reason)}>
            {reason}
          </Tag.CheckableTag>
        ))}
      </Space>
    </Space>
  );
}
